import React, {  Fragment } from 'react';

import { TextValidator } from 'react-material-ui-form-validator';
import Button from '@mui/material/Button';
import FormLabel from '@mui/material/FormLabel';
import Grid from '@mui/material/Grid';

import { AutoTextValidator } from './GridComponents';

/*
<ContactBox 
contactTemplates = {this.state.contactTemplates}
contactTemplate = {this.state.contactTemplate}
onAutoChange = {this.onAutoChange} ###3
classes = {classes}
onAddContactTemplate = {this.onAddContactTemplate} ###
onTextChange = {this.onTextChange} ###
contactFirstname = {this.state.contactFirstname}
contactLastname = {this.state.contactLastname}
contactPhone = {this.state.contactPhone}
contactEmail = {this.state.contactEmail}
/>
*/

const ContactBox = props => {

    const { classes } = props;

    const addingContactTemplate = () => {

        if(props.contactFirstname !== '' && props.contactLastname !== '' ){
            props.onAddContactTemplate()
        }
        
    }

    return (
        <>
            <Grid container  spacing={3}>
               <Grid item xs={12}>
                        <br />
                        <FormLabel component="legend">{"Contact"}</FormLabel>
                        <p>Select a saved contact from the list. If your contact is not listed, fill in the fields below, then click Save contact. </p>
                    </Grid>
                    <Grid item xs={6}>
                        <AutoTextValidator
                            name="contactTemplate"
                            options={ props.contactTemplates}
                            value={ props.contactTemplate}
                            onChange={ props.onAutoChange}
                            classes={classes}
                            label="Saved Contact"
                        />
                    </Grid>
                    
                    <Grid item xs={12} sm={6} lg={3}>
                        <TextValidator
                            id="standard-basic"
                            label="First Name"
                            type="text"
                            className={[classes.textField].join(' ')}
                            onChange={props.onTextChange}
                            value={ props.contactFirstname}
                            name='contactFirstname'
                            validators={['required']}
                            errorMessages={['First name is required']}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                        <TextValidator
                            id="standard-basic"
                            label="Last Name"
                            type="text"
                            className={[classes.textField].join(' ')}
                            onChange={props.onTextChange}
                            value={props.contactLastname}
                            name='contactLastname'
                            validators={['required']}
                            errorMessages={['Last name is required']}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                        <TextValidator
                            id="standard-basic"
                            label="Contact Phone"
                            type="tel"
                            className={[classes.textField].join(' ')}
                            placeholder='987-654-3210 x1234'
                            onChange={props.onTextChange}
                            value={props.contactPhone}
                            name='contactPhone'
                            validators={['required', 'matchRegexp:^(\\+\\d{1,3}\\s?)?((\\(\\d{3}\\)\\s?)|(\\d{3})(\\s|-?))(\\d{3}(\\s|-?))(\\d{4})(\\s?(([E|e]xt[:|.|]?)|x|X)(\\s?\\d+))?$']}
                            errorMessages={['Phone is required', 'Only "(", ")", "-", "x", and numbers are allowed. Must be at least 10 digits']}
                            fullWidth
                            required
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={3}>
                        <TextValidator
                            id="standard-basic"
                            label="Contact Email"
                            type="email"
                            className={[classes.textField].join(' ')}
                            placeholder='example@domain.com'
                            onChange={props.onTextChange}
                            value={props.contactEmail}
                            name='contactEmail'
                            validators={['required', 'isEmail']}
                            errorMessages={['Email is required', 'Please enter a valid email address']}
                            fullWidth
                            required
                        />
                    </Grid>

                    <Grid item xs={6}>
                        {! props.contactTemplate  &&
                        <Button
                            variant="outlined"
                            color="primary"
                            className={[].join(' ')}
                            onClick={addingContactTemplate}
                        >
                        Save Contact
                        </Button>
                        }
                        {/* { props.contactTemplate && 
                            <Button
                            variant="outlined"
                            color="primary"
                            className={[].join(' ')}
                            href="mailto:gi.bmp@ifas.ufl.edu?subject=Update Contact Template"
                        >Email to Update Contact Template
                        </Button>
                        } */}
                    </Grid>
            </Grid>
        </>

    )
}

export default ContactBox;
//export default TrainingHist